import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import ConfirmationModal from '../../../../components/ConfirmationModal'

const DbaConfirmationModal = function ({ showSignal, model, afterMessage=null }) {

	const closeModal = () => {
		showSignal.value = false
	}

	return (
		<>
			<Modal show={showSignal.value} onHide={closeModal}>
				<Modal.Header closeButton>
					<Modal.Title className="modal-title">{
						(
							model.modalTitle ? (<>{model.modalTitle}</>) : (<>Connection Successful</>)
						)
					}</Modal.Title>
				</Modal.Header>
				<Form>
					<Modal.Body>
						<h4 className='inline-block modal-subhead'>This merchant is connected to the following DOLLARS ON THE NET merchant.</h4>
						<div>
							<Form.Group>
								{
									model.name && (
										<>
											<label className="col-xs-3 control-label">Name</label>
											<div className="col-xs-8 control-label edit-label readonly">{model.name}</div>
										</>
									)
								}
								{
									model.merchantType && (
										<>
											<label className="col-xs-3 control-label">Type</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.merchantType}
											</div>
										</>
									)
								}
								{
									model.currencyCode && (
										<>
											<label className="col-xs-3 control-label">Currency Code</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.currencyCode}
											</div>
										</>
									)
								}
								{
									model.addressLine1 && (
										<>
											<label className="col-xs-3 control-label">Address Line 1</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.addressLine1}
											</div>
										</>
									)
								}
								{
									model.addressLine2 && (
										<>
											<label className="col-xs-3 control-label">Address Line 2</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.addressLine2}
											</div>
										</>
									)
								}
								{
									model.city && (
										<>
											<label className="col-xs-3 control-label">City</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.city}
											</div>
										</>
									)
								}
								{
									model.state && (
										<>
											<label className="col-xs-3 control-label">State</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.state}
											</div>
										</>
									)
								}
								{
									model.zipCode && (
										<>
											<label className="col-xs-3 control-label">ZIP/Postal Code</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.zipCode}
											</div>
										</>
									)
								}
								{
									model.phone && (
										<>
											<label className="col-xs-3 control-label">Phone</label>
											<div className="col-xs-9 control-label edit-label readonly">
												{model.phone}
											</div>
										</>
									)
								}
							</Form.Group>
							{
								afterMessage && (
									<h4 className='inline-block modal-subhead'>{afterMessage}</h4>
								)
							}
						</div>
					</Modal.Body>
					<Modal.Footer>
						{
							model && (
								<Button onClick={closeModal}>OK</Button>
							)
						}
					</Modal.Footer>
				</Form>
			</Modal>
			<ConfirmationModal /* the original ember template has a confirmation modal, purpose unknown*/
				hidden
				show={false}
				handleCancel={() => { }}
				handleConfirm={() => { }}
				message={"Message"}
				title={"Title"}
				confirmText={"Yes"}
				cancelText={"No"}
			></ConfirmationModal>
		</>
	)
}
export default DbaConfirmationModal